//dependencias
import React, { Component } from 'react';

//componentes
import DosificacionEvaAd from './dosificacionEvaAd'

class Index extends Component {

    render(){
        return(
            <div>
                <DosificacionEvaAd />
            </div>
        );
    }

}
export default Index;